import * as React from 'react';

import { DataGrid, MUIRadioButton, Pagination } from '@abb/arcadia-ui-react';

import { ISiteModel } from '@module/shared/components/Site/models';
import { API_SUPPORT_EMAIL } from '@service/constants';

/* tslint:disable:jsx-no-lambda */
export default class Sites extends React.Component<any, any> {
    public render() {
        const { sites } = this.props;

        if (this.props.sites.length > 0 || this.props.sitesLoading) {
            const headerData = [
                { id: 'Select', label: '', numeric: false, actions: false, enableSort: false },
                { id: 'SiteName', label: 'Site Name', numeric: false, actions: false, enableSort: true },
                { id: 'ServIsId', label: 'ServIS ID', numeric: false, actions: false, enableSort: true },
                { id: 'Owner', label: 'Customer (Owner)', numeric: false, actions: false, enableSort: true },
                { id: 'RegionName', label: 'Region', numeric: false, actions: false, enableSort: true },
                { id: 'Registered', label: 'Registered', numeric: false, actions: false, enableSort: true }
            ];
            const rows = sites.map((site: ISiteModel) => ({
                id: String(site.siteId),
                Select: (
                    <MUIRadioButton
                        size={16}
                        selected={this.props.siteSelected && this.props.selectedSite?.servIsId === site.servIsId ? String(site.siteId) : ''}
                        radioItems={[{ label: '', value: String(site.siteId) }]}
                        handleValueChange={() => this.props.onCheck(site)}
                    />
                ),
                SiteName: site.name,
                ServIsId: site.servIsId,
                Owner: site.customer,
                RegionName: site.region,
                Registered: site.registered ? 'Yes' : 'No'
            }));
            return (
                <div className='sites-table-wrapper'>
                    <div className='sites-table-scroll'>
                        <DataGrid
                            name='register-sites'
                            size={40}
                            enableCheckbox={false}
                            rowsPerPage={rows.length || 1}
                            headerData={headerData}
                            rows={rows}
                            onSortChange={(sort: { column: string; direction: 'asc' | 'desc' }) => { this.props.sortField(sort.column); }}
                        />
                    </div>
                    <div className='sites-pagination'>
                        <Pagination
                            count={this.props.totalNumberOfSites}
                            rowsPerPage={this.props.pagingSettings.pageSize}
                            page={Math.floor(this.props.pagingSettings.skipItems / this.props.pagingSettings.pageSize)}
                            handleChangePage={(event: any, page: number) => this.props.requestPage(page * this.props.pagingSettings.pageSize)}
                            handleChangeRowsPerPage={(event: any) => this.props.requestRowsPerPage(Number(event.target.value))}
                        />
                    </div>
                </div>
            );
        } else {
            if (this.props.searchFilter.length > 0) {
                return (
                    <div style={{ padding: "16px" }}>
                        <p>No results found based on provided search criteria.</p>
                        <p>Make sure all words are spelled correctly.</p>
                        <p>Try again or contact customer Support at <a href={`mailto:${API_SUPPORT_EMAIL}`}>{API_SUPPORT_EMAIL}.</a></p>
                    </div>
                );
            } else {
                return (
                    <div>
                        <p>No ServIS sites available to register.</p>
                        <p>Contact customer Support at <a href={`mailto:${API_SUPPORT_EMAIL}`}>{API_SUPPORT_EMAIL}</a> to gain access.</p>
                    </div>
                );
            }
        }
    }
}
